var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ml-3",style:('cursor : pointer;'),on:{"click":_vm.handleUpload}},[_c('input',{ref:"excel-upload-input",staticClass:"excel-upload-input",attrs:{"type":"file","accept":".xlsx, .xls","color":"primary"},on:{"change":_vm.handleClick}}),_c('span',{staticClass:"black--text ml-n1"},[_vm._v("IMPORT")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }